import { useEffect } from 'react';
import axios from 'axios';
import './PromoRedirectPage.css'; 

const PromoRedirectPage = () => {
    useEffect(() => {
        if (window.location.pathname === '/promo') {
            const callCallbackAndRedirect = async () => {
                try {
                    await axios.get('/header?source=promo');
                    window.location.href = "http://consent.hutch.lk/register-service/VQ%3D%3DCg%3D%3DdQ%3D%3D";
                } catch (error) {
                    console.error("ERROR:", error);
                }
            };

            callCallbackAndRedirect();
        }
    }, []);

    return (
        <div className="promo-container">
            <div className="promo-loader"></div>
        </div>
    );
};

export default PromoRedirectPage;
